import { RendererFactory2 } from '@angular/core';
import { environment } from '../../../../../environments/environment';

export const tawkToFactory = (rendererFactory: RendererFactory2) => {
  return () => {
    // TODO: Probably naming is wrong
    const tawkToProjectId = environment.tawkToProjectId;
    const tawkToChatId = environment.tawkToChatId;
    if (!tawkToProjectId || !tawkToChatId) {
      return;
    }

    const renderer = rendererFactory.createRenderer(null, null);
    const script = renderer.createElement('script');
    script.type = 'text/javascript';
    script.text = `
    var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
    (function(){
      var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
      s1.async=true;
      s1.src='https://embed.tawk.to/${tawkToProjectId}/${tawkToChatId}';
      s1.charset='UTF-8';
      s1.setAttribute('crossorigin','*');
      s0.parentNode.insertBefore(s1,s0);
    })();
    `;
    renderer.appendChild(document.head, script);
  };
};
